/// <reference path="../../polaris-web-components.d.ts" />
import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * 
 * @param {boolean} show 
 * @param {string} message 
 * @param {string} feature 
 * @param {function} onDismiss 
 * @param {function} onUpgrade 
 */
function UpgradeBanner({ show, message, feature, onDismiss, onUpgrade }) {
    const navigate = useNavigate();
    const queryString = window.location.search;

    if (!show) return null;

    const handleUpgrade = () => {
        if (onUpgrade) {
            onUpgrade();
        } else {
            navigate('/plans' + queryString);
        }
    };

    const defaultMessage = message || 'This feature requires a Pro plan subscription. Upgrade now to unlock unlimited products, advanced features, and priority support.';

    return (
        <s-box paddingBlockEnd="large">
            <s-banner
                heading="Upgrade to Pro Required"
                tone="info"
                dismissible
                onDismiss={onDismiss}
            >
                <s-stack gap="small">
                    <s-text>{defaultMessage}</s-text>
                    {feature && (
                        <s-text color="subdued" size="small">
                            Feature: <s-text type="strong">{feature}</s-text>
                        </s-text>
                    )}
                </s-stack>
                <s-button slot="secondary-actions" onClick={handleUpgrade}>
                    Upgrade Now
                </s-button>
            </s-banner>
        </s-box>
    );
}

export default UpgradeBanner;

